import React from "react";
import "./Volunteering.css";

import tealsLogo from "../assets/Teals.png";
import codeOrgLogo from "../assets/Code.org_logo.svg.png";
import derbyHighLogo from "../assets/DerbyHighSchool.png";

function Volunteering() {
  return (
    <section id="volunteering" className="section bg-dark">
      <div className="container">
        <h2 className="section-title">Community & Volunteering</h2>
        <div className="volunteer-list">
          {/* --- Card 1: Combined Role --- */}
          <div className="volunteer-card">
            <div className="volunteer-icon-container">
              <a
                href="https://www.microsoft.com/en-us/teals"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={tealsLogo}
                  alt="Microsoft TEALS Logo"
                  className="logo"
                />
              </a>
              <a
                href="https://code.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={codeOrgLogo} alt="Code.org Logo" className="logo" />
              </a>
            </div>
            <div className="volunteer-info">
              <h3 className="volunteer-title">CS Education Advocate</h3>
              <p className="volunteer-description">
                Microsoft TEALS & Code.org
              </p>
              {/* --- DATES ADDED HERE --- */}
              <p className="volunteer-dates">2019 - Present</p>

              <div className="volunteer-details">
                <ul>
                  <li>
                    Co-teach high school Computer Science to bring CS to
                    underserved communities, remotely lead lectures in Intro to
                    Computer Science for high school students.
                  </li>
                  <li>
                    Lead hands-on coding workshops and mentor students in
                    programming labs.
                  </li>
                  <li>
                    Collaborate with local educators to develop engaging lesson
                    plans.
                  </li>
                </ul>
              </div>
              <div className="volunteer-links">
                <a
                  href="https://www.microsoft.com/en-us/teals"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="volunteer-link"
                >
                  Visit TEALS
                </a>
                <a
                  href="https://code.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="volunteer-link"
                >
                  Visit Code.org
                </a>
              </div>
            </div>
          </div>

          {/* --- Card 2: Single Role --- */}
          <div className="volunteer-card">
            <div className="volunteer-icon-container">
              <a
                href="https://www.anotherexample.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={derbyHighLogo}
                  alt="Another Org Logo"
                  className="logo"
                />
              </a>
            </div>
            <div className="volunteer-info">
              <h3 className="volunteer-title">
                Technology Advisory Board Member
              </h3>
              <p className="volunteer-description">Derby High School</p>
              {/* --- DATES ADDED HERE --- */}
              <p className="volunteer-dates">2017 - 2018</p>

              <div className="volunteer-details">
                <ul>
                  <li>
                    Attended monthly meetings to discuss technology integration
                    in the schools and provide feedback on tech initiatives.
                  </li>
                  <li>
                    Stay apprised of the latest educational technology trends
                    and share insights with the board.
                  </li>
                  <li>
                    Collaborated with educators to enhance the use of technology
                    in the classroom.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Volunteering;
